import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider';
import { getLanguageSettings } from '@/scopes/common/domain/policies/site';
import { isClient } from '@/utilities';
import { Icon, space, Typography, tk } from '@sunwebgroup/ui-components';
import * as React from 'react';
import { styled } from 'styled-components';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useIntl } from '@/intl';
import { Dropdown } from './Dropdown';

export function LanguageSwitch() {
  const siteName = useConfiguration('siteName');
  const intl = useIntl();
  const langSettings = getLanguageSettings(siteName);

  if (!langSettings) return null;

  const matchesLanguageWithUrl = (urlMatcher: string) => {
    if (!isClient()) return false;

    const url = window.location.href;
    return url.includes(urlMatcher);
  };

  return (
    <Dropdown.Menu>
      <Trigger>
        <Icon glyph="IconLanguage" size="md" />
        <Icon glyph="IconChevronDownSmall" size="md" />
      </Trigger>
      <MenuContent align="end" sideOffset={5}>
        {langSettings.map((setting) => (
          <LanguageMenuItem key={setting.url}>
            {matchesLanguageWithUrl(setting.urlMatcher) ? (
              <Icon glyph="IconCheckmarkSmall" size="md" />
            ) : (
              <MenuSpacer />
            )}
            <LanguageLink href={setting.url}>
              <Typography>{intl.formatMessage({ id: `${setting.translationKey}` })}</Typography>
            </LanguageLink>
          </LanguageMenuItem>
        ))}
      </MenuContent>
    </Dropdown.Menu>
  );
}

const LanguageMenuItem = styled.div`
  display: flex;
  padding-right: ${space('primitives_space_8')};
`;

const MenuSpacer = styled.div`
  width: ${space('primitives_space_24')};
`;

const MenuContent = styled(DropdownMenu.Content)`
  padding: ${space('primitives_space_16')};
  align-items: flex-start;
  background: ${tk('color_semantic_bg')};
  border-radius: ${tk('radius_large')};
  box-shadow: ${tk('shadow_lg_bottom')};
  display: flex;
  flex-direction: column;
  z-index: 1;
`;

const LanguageLink = styled.a`
  text-decoration: none;
`;

const Trigger = styled(Dropdown.Trigger)`
  padding: ${space('primitives_space_8')};
  margin-right: ${space('primitives_space_4')};
`;
